export * from './delete-zeit.component';
export * from './delete-zeit.component.module';